import React from 'react'

const Proposal = () => {
  return <iframe src="/files/proposal.pdf" title="Proposal" />;
}
export default Proposal;